import React from 'react'
import ReactDOM from 'react-dom'
import * as serviceWorker from './serviceWorker'
import 'antd/dist/antd.css'
import './index.less'
import { HashRouter } from 'react-router-dom'
import AppMobile from './entry/mobile/AppMobile'
// import { mobileUserInfo } from '@ibingli/web-bridge'

// Reflect.set(
//     window,
//     'mobileUserInfo',
//     mobileUserInfo(() => {
//         Reflect.set(window, 'mobileUserInfoLoaded', true)
//     }),
// )

// const LazyAppWeb = lazy(() => import('./entry/web/AppWeb'))

ReactDOM.render(
    <HashRouter>
        <AppMobile />
    </HashRouter>,
    document.getElementById('root'),
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
